import { render, staticRenderFns } from "./TrashCan.vue?vue&type=template&id=e1d11a78&"
import script from "./TrashCan.vue?vue&type=script&lang=js&"
export * from "./TrashCan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports